import { Component } from '@angular/core';

@Component({
  selector: 'app-information-sidebar-feedback-unprompted',
  templateUrl: './information-sidebar-feedback-unprompted.component.html',
  styleUrls: ['./information-sidebar-feedback-unprompted.component.scss']
})
export class InformationSidebarFeedbackUnpromptedComponent {
}
